const toast = document.querySelector(".toast");
const finder = document.querySelector(".ymm-search");
const headerSearch = document.querySelector(".header-search");
const headerSearchToggle = document.querySelector("[data-search-toggle]");
const headerSearchInput = document.querySelector("#header-search-input");
const storeSearchBand = document.querySelector(".store-search-band");
const heroSection = document.querySelector(".hero");
const cartCount = document.querySelector("[data-cart-count]");
const productFilters = Array.from(document.querySelectorAll("[data-product-filter]"));
const productCards = Array.from(document.querySelectorAll("[data-product-card]"));
const scrollButtons = Array.from(document.querySelectorAll("[data-scroll-target]"));
const video = document.querySelector(".hero-video");
const brandSlider = document.querySelector("[data-brand-slider]");
const snapSections = [heroSection, ...Array.from(document.querySelectorAll("main > section")), document.querySelector(".site-footer")].filter(Boolean);
let cartItems = 0;
let isSectionSnapScrolling = false;
let sectionSnapReleaseTimer;

const refreshLucideIcons = () => {
  if (!window.lucide) return;
  window.lucide.createIcons({
    attrs: {
      "aria-hidden": "true",
    },
  });
};

refreshLucideIcons();

const showToast = (message) => {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-visible");
  window.clearTimeout(showToast.timeout);
  showToast.timeout = window.setTimeout(() => {
    toast.classList.remove("is-visible");
  }, 2600);
};

const addPremierBuild = (message = "Added to your Premier build") => {
  cartItems += 1;
  if (cartCount) cartCount.textContent = String(cartItems);
  showToast(message);
};

const searchPlaceholders = [
  "Search forged wheels",
  "Search tire packages",
  "Search air suspension",
  "Search lighting upgrades",
];
let searchPlaceholderIndex = 0;
let searchPlaceholderTimer;

const cycleSearchPlaceholder = () => {
  if (!headerSearchInput) return;
  headerSearchInput.placeholder = searchPlaceholders[searchPlaceholderIndex];
  searchPlaceholderIndex = (searchPlaceholderIndex + 1) % searchPlaceholders.length;
};

const openHeaderSearch = () => {
  if (!headerSearch || !headerSearchInput || !headerSearchToggle) return;
  headerSearch.classList.add("is-open");
  headerSearchToggle.setAttribute("aria-expanded", "true");
  cycleSearchPlaceholder();
  window.clearInterval(searchPlaceholderTimer);
  searchPlaceholderTimer = window.setInterval(cycleSearchPlaceholder, 1500);
  headerSearchInput.focus();
};

const closeHeaderSearch = () => {
  if (!headerSearch || !headerSearchInput || !headerSearchToggle) return;
  if (headerSearchInput.value.trim()) return;
  headerSearch.classList.remove("is-open");
  headerSearchToggle.setAttribute("aria-expanded", "false");
  window.clearInterval(searchPlaceholderTimer);
};

const syncStickyStoreBand = () => {
  if (!storeSearchBand) return;
  if (!heroSection) {
    storeSearchBand.classList.add("is-stuck");
    return;
  }

  const topStripHeight = document.querySelector(".top-strip")?.offsetHeight || 0;
  const storeBandHeight = storeSearchBand.offsetHeight || 0;
  const stickyTrigger = Math.max(heroSection.offsetHeight - (topStripHeight + storeBandHeight), 0);
  const shouldStick = window.scrollY >= stickyTrigger;
  storeSearchBand.classList.toggle("is-stuck", shouldStick);
};

const desktopSnapMedia = window.matchMedia("(hover: hover) and (pointer: fine)");
const reducedMotionMedia = window.matchMedia("(prefers-reduced-motion: reduce)");

const canUseSectionSnap = () =>
  desktopSnapMedia.matches &&
  !reducedMotionMedia.matches &&
  window.innerWidth >= 900;

const syncSectionSnapMode = () => {
  document.documentElement.classList.toggle("has-section-snap", canUseSectionSnap());
  document.body.classList.toggle("has-section-snap", canUseSectionSnap());
};

const getStickyScrollOffset = (target) => {
  if (!target || target === heroSection) return 0;
  const topStripHeight = document.querySelector(".top-strip")?.offsetHeight || 0;
  const storeBandHeight = storeSearchBand?.offsetHeight || 0;
  return topStripHeight + storeBandHeight + 14;
};

const getSnapTargetTop = (target) => {
  if (!target) return 0;
  return Math.max(target.offsetTop - getStickyScrollOffset(target), 0);
};

const getClosestSnapSectionIndex = () => {
  if (!snapSections.length) return 0;

  let closestIndex = 0;
  let closestDistance = Number.POSITIVE_INFINITY;

  snapSections.forEach((section, index) => {
    const distance = Math.abs(window.scrollY - getSnapTargetTop(section));
    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
};

const scrollToSnapSection = (index) => {
  const boundedIndex = Math.max(0, Math.min(index, snapSections.length - 1));
  const target = snapSections[boundedIndex];
  if (!target) return;

  isSectionSnapScrolling = true;
  window.clearTimeout(sectionSnapReleaseTimer);
  window.scrollTo({
    top: getSnapTargetTop(target),
    behavior: "smooth",
  });

  sectionSnapReleaseTimer = window.setTimeout(() => {
    isSectionSnapScrolling = false;
  }, 760);
};

const shouldIgnoreSectionSnap = (eventTarget) => {
  if (!eventTarget || !(eventTarget instanceof Element)) return false;
  return Boolean(
    eventTarget.closest(
      "input, select, textarea, button, a, summary, details, [contenteditable='true'], .brand-slider-viewport, .store-menu",
    ),
  );
};

finder?.addEventListener("submit", (event) => {
  event.preventDefault();
  const data = new FormData(finder);
  const fitment = [
    data.get("year"),
    data.get("make"),
    data.get("model"),
  ]
    .filter(Boolean)
    .join(" ");
  showToast(`Searching Premier-compatible ${fitment} packages`);
});

headerSearchToggle?.addEventListener("click", () => {
  if (headerSearch?.classList.contains("is-open")) {
    headerSearchInput?.focus();
    return;
  }
  openHeaderSearch();
});

headerSearch?.addEventListener("submit", (event) => {
  event.preventDefault();
  const query = headerSearchInput?.value.trim();
  showToast(query ? `Searching Premier for ${query}` : "Search Premier wheels, tires, suspension, and lighting");
});

headerSearchInput?.addEventListener("blur", () => {
  window.setTimeout(closeHeaderSearch, 120);
});

document.querySelectorAll("[data-utility-action]").forEach((button) => {
  button.addEventListener("click", () => {
    showToast(`${button.dataset.utilityAction} opened`);
  });
});

productFilters.forEach((button) => {
  button.addEventListener("click", () => {
    const filter = button.dataset.productFilter || "all";
    productFilters.forEach((item) => item.classList.toggle("is-active", item === button));
    productCards.forEach((card) => {
      const tags = card.dataset.tags || "all";
      card.classList.toggle("is-hidden", filter !== "all" && !tags.includes(filter));
    });
  });
});

document.querySelectorAll(".wishlist").forEach((button) => {
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    button.classList.toggle("is-saved");
    showToast(button.classList.contains("is-saved") ? "Saved to garage" : "Removed from garage");
  });
});

document.querySelectorAll("[data-add-build]").forEach((button) => {
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    addPremierBuild();
  });
});

document.querySelectorAll("[data-product-card]").forEach((item) => {
  item.addEventListener("click", (event) => {
    if (event.target.closest(".wishlist, [data-add-build]")) return;
    addPremierBuild();
  });
});

document.querySelectorAll(".platform-grid button").forEach((button) => {
  button.addEventListener("click", () => {
    showToast(`${button.textContent.trim()} fitments selected`);
    document.querySelector("#collection-preview")?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

document.querySelectorAll(".filter-panel button").forEach((button) => {
  button.addEventListener("click", () => {
    document.querySelectorAll(".filter-panel button").forEach((item) => {
      item.classList.toggle("is-active", item === button);
    });
    showToast(`${button.textContent.trim()} filter applied`);
  });
});

scrollButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const target = document.querySelector(button.dataset.scrollTarget);
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

if (brandSlider) {
  const brandTrack = brandSlider.querySelector("[data-brand-slider-track]");
  const brandPages = Array.from(brandSlider.querySelectorAll("[data-brand-page]"));
  const brandDots = Array.from(document.querySelectorAll("[data-brand-dot]"));
  const brandPrev = brandSlider.querySelector("[data-brand-slider-prev]");
  const brandNext = brandSlider.querySelector("[data-brand-slider-next]");
  let brandIndex = 0;

  const syncBrandSlider = () => {
    if (!brandTrack) return;
    brandTrack.style.transform = `translateX(-${brandIndex * 100}%)`;
    brandDots.forEach((dot, index) => {
      const isActive = index === brandIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", String(isActive));
    });
  };

  brandPrev?.addEventListener("click", () => {
    brandIndex = (brandIndex - 1 + brandPages.length) % brandPages.length;
    syncBrandSlider();
  });

  brandNext?.addEventListener("click", () => {
    brandIndex = (brandIndex + 1) % brandPages.length;
    syncBrandSlider();
  });

  brandDots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      brandIndex = index;
      syncBrandSlider();
    });
  });

  syncBrandSlider();
}

document.querySelector(".newsletter")?.addEventListener("submit", (event) => {
  event.preventDefault();
  showToast("You are on the Premier offers list");
});

window.addEventListener("keydown", (event) => {
  if (!canUseSectionSnap() || isSectionSnapScrolling) return;
  if (shouldIgnoreSectionSnap(event.target)) return;

  let direction = 0;
  if (event.key === "PageDown" || event.key === "ArrowDown" || (event.key === " " && !event.shiftKey)) {
    direction = 1;
  } else if (event.key === "PageUp" || event.key === "ArrowUp" || (event.key === " " && event.shiftKey)) {
    direction = -1;
  }

  if (!direction) return;

  event.preventDefault();
  const currentIndex = getClosestSnapSectionIndex();
  scrollToSnapSection(currentIndex + direction);
});

syncSectionSnapMode();
syncStickyStoreBand();
window.addEventListener("load", () => {
  syncSectionSnapMode();
  syncStickyStoreBand();
});
window.addEventListener("scroll", syncStickyStoreBand, { passive: true });
window.addEventListener("resize", () => {
  syncSectionSnapMode();
  syncStickyStoreBand();
});

if (video) {
  video.muted = true;
  video.play().catch(() => {
    showToast("Tap the hero video to play");
  });

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    },
    { threshold: 0.18 },
  );
  observer.observe(video);
}
